import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxLoadingModule } from 'ngx-loading';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { ModalComponent } from './component/modal/modal.component';
import { ToastComponent } from './component/toast/toast.component';
import { SearchComponent } from './component/search/search.component';
import { QuoteSummaryComponent } from './component/quote-summary/quote-summary.component';
import { ControlMessageComponent } from './component/control-message/control-message.component';

import { MasterDataTranslatePipe } from './pipe/masterdata-translate.pipe';

import { NumbersOnlyDirective } from './directive/numbers-only.directive';
import { ExcludePipeCharacterDirective } from './directive/exclude-pipe-character.directive';
import { ExcludeSpecialCharacterDirective } from './directive/exclude-special-character.directive';

const sharedDeclarations: Array<Type<any> | any[]> = [
  ModalComponent,
  SearchComponent,
  QuoteSummaryComponent,
  ControlMessageComponent,
  MasterDataTranslatePipe,
  NumbersOnlyDirective,
  ExcludePipeCharacterDirective,
  ExcludeSpecialCharacterDirective
];

@NgModule({
    declarations: [...sharedDeclarations, ToastComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        NgSelectModule,
        NgbDatepickerModule,
        NgxLoadingModule,
        MatSnackBarModule,
        TooltipModule.forRoot(),
        ModalModule.forRoot()
    ],
    exports: [
        ...sharedDeclarations,
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        NgSelectModule,
        NgxLoadingModule,
        NgbDatepickerModule,
        MatSnackBarModule,
        TooltipModule,
        ModalModule
    ]
})
export class SharedModule {}
